var $47432cefd4b7bd1b$exports = {};
$47432cefd4b7bd1b$exports = {
  "decrease": function decrease(args) {
    return "Samazin\u0101\u0161ana ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Palielin\u0101\u0161ana ".concat(args.fieldLabel);
  },
  "numberField": "Skait\u013Cu lauks"
};
export { $47432cefd4b7bd1b$exports as default };